import React from "react";
import { useTranslation } from "react-i18next";
import { IconApple } from "../../components/icons";
import { commonUtil } from "../../utils";
import { loginApple } from "../../api";
import { Button } from "antd";

interface Props {
  onLoginFail?: () => void;
  onLoginSuccess: (
    accessToken: string,
    refreshToken: string,
    expires: number
  ) => void;
}

const LoginApple: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const onClickLoginApple = async () => {
    const data = await window.AppleID.auth.signIn();
    await handleAppleIdToken(data.authorization.id_token);
  };

  const handleAppleIdToken = async (idToken: string) => {
    const res = await loginApple({ idToken });

    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    props.onLoginSuccess(
      res.data.access_token,
      res.data.refresh_token,
      res.data.expires_in
    );
  };

  return (
    <Button
      block={true}
      onClick={onClickLoginApple}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconApple />
      <span>{t("common:Đăng nhập bằng Apple ID")}</span>
    </Button>
  );
};

export default LoginApple;
